export const SERIES_SHOW_TABS = [
  'general',
  'publications',
  'collection',
  'search',
] as const;

export type SeriesShowTab = (typeof SERIES_SHOW_TABS)[number];

export const SERIES_DEFAULT_TAB: SeriesShowTab = 'general';
